import { Injectable } from "@angular/core";
import { ApiService } from "../../../services/api/api.service";
import { Observable } from "rxjs";
import { CommissionDataDto, CommissionsSizeDto, CurrencyListDto, P2PRequestDto, PaymentInfoDto } from "../models/payment-to-card.models";
import { UserInfoService } from "../../../services/user-info.service";

@Injectable({
  providedIn: "root",
})
export class PaymentToCardDataService {
  agentId: string | undefined;
  userId: number | undefined;

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService
  ) {
    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res;
      },
    });

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res;
      },
    });
  }

  getVirtualPosP2pId(): Observable<{ currency: string; id: string }> {
    const url = `/agents/${this.agentId}/virtual_pos/p2p`;
    return this.apiService.httpGet(url);
  }

  getCommission(data: CommissionsSizeDto): Observable<CommissionDataDto> {
    const url = `/banks/payer_commission`;
    return this.apiService.httpPost<CommissionDataDto>(url, data);
  }

  sendP2p(data: P2PRequestDto): Observable<any> {
    const url = `/banks/call`;
    return this.apiService.httpPost<any>(url, data);
  }

  getPaymentInfo(token: string): Observable<PaymentInfoDto> {
    const url = `/banks/payment_info?token=${token}`;
    return this.apiService.httpGet<PaymentInfoDto>(url);
  }
}
